<template>
  <div>
    <div class="page-content">
      <div class="container-fluid">
        <div class="card">
          <div class="card-head">
            收款码管理
          </div>
          <div class="card-body padding-top0">
            <div class="card-menu">
              <Alert>
                （必传）活码：也就是通用码，为没有固定金额的微信/支付宝收款码，用户支付时需手动输入金额<br><br>
                （选传）固码：为固定金额的微信/支付宝收款码，需在微信/支付宝收款码界面自行生成不同金额的码
              </Alert>
              <Row>
                <Col :xs="{ span: 24 }" :lg="{ span: 12 }" style="margin: 5px 0">
                <Button type="success" style="margin-right :10px" icon="md-add" @click="upload">上传收款码</Button>
                <Button type="error" icon="md-trash" @click="allDel" :loading="loading"
                  :disabled="Selection.length==0?true:false">删除所选</Button>
                </Col>

                <Col :xs="{ span: 24 }" :lg="{ span: 12 }" :style="`margin: 5px 0;text-align:${$store.state.isMobile?'left':'right'}`">
                <RadioGroup v-model="type" type="button" button-style="solid" @on-change="_getData()">
                  <Radio label="-1">全部码</Radio>
                  <Radio label="alipay">支付宝码</Radio>
                  <Radio label="wxpay">微信码</Radio>
                </RadioGroup>
                </Col>

              </Row>

            </div>
            <div v-if="data.length == 0 && !load">
              <Empty :text="'暂无数据'"></Empty>
            </div>
            <div v-else>
              <Table ref="selection" border :loading="load" :columns="columns" :data="data"
                @on-selection-change="handleSelectChange">
                <template slot-scope="{ row }" slot="type">
                  <span v-if="row.type == 'wxpay'">微信</span>
                  <span v-else>支付宝</span>
                </template>
                <template slot-scope="{ row }" slot="price">
                  <span v-if="row.category == 2">通用</span>
                  <span v-else>{{row.price}}</span>
                </template>
                <template slot-scope="{ row }" slot="action">
                  <Button size="small" type="primary" style="margin-right: 5px" @click="readClick(row)">查看</Button>
                  <Button type="error" size="small" @click="del(row.id)">删除</Button>
                </template>
              </Table>
              <div class="paging">
                <Page :total="Number(total)" :current="pageIndex" :page-size="pageSize" :simple="$store.state.isMobile"
                  @on-change="pageChange" @on-page-size-change="pageSizeChange" show-total show-sizer show-elevator />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Modal draggable mask sticky reset-drag-position v-model="modal" :width="300" footer-hide
      :title="qrItem.category == 2?'通用码':qrItem.price+'元码'">
      <img :src="qrItem.qr_img" alt="">
    </Modal>
    <Modal v-model="modal2" title="收款码上传" @on-ok="ok" :width="350" :loading="loading3">
      <Upload class="upload-main" type="drag" :action="action" :data="dataUp" :headers="headers"
        :show-upload-list="false" :format="['jpg', 'jpeg', 'png', 'gif']"
        accept="image/gif,image/jpeg,image/jpg,image/png" :max-size="5120" :default-file-list="defaultList"
        :on-success="handleSuccess2" :on-format-error="handleFormatError" :on-exceeded-size="handleMaxSize"
        :before-upload="beforeUpload2" :on-error="onError">

        <div class="qr-img" v-if="upItem.qr_img">
          <img :src="upItem.qr_img" alt="">
        </div>
        <div v-else class="qr-icon">
          <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
          <p>请上传收款码</p>
        </div>
      </Upload>

      <div class="input-main">
        分类：
        <RadioGroup v-model="dataUp.type">
          <Radio label="wxpay">微信码</Radio>
          <Radio label="alipay">支付宝码</Radio>
        </RadioGroup>
      </div>
      <div class="input-main">
        类型：
        <RadioGroup v-model="dataUp.category">
          <Radio :label="2">活码</Radio>
          <Radio :label="1">固码</Radio>
        </RadioGroup>
      </div>
      <div class="input-main" v-if="dataUp.category == 1">
        金额：
        <InputNumber v-model="dataUp.price" placeholder="请输入金额" style="width: 240px">
        </InputNumber>
      </div>
    </Modal>
  </div>
</template>

<script>
  import {
    postGeekPay,
    getGeekPay,
    delGeekPay,
  } from "@/api/admin";
  export default {
    data() {
      return {
        action: window.config.Base_url + "/admin/geekPay/save",
        headers: {
          Token: sessionStorage.getItem("token"),
        },
        dataUp: {
          type: "wxpay",
          category: 2,
          price: 0
        },

        defaultList: [],
        Selection: [],
        pageIndex: 1,
        pageSize: 10,
        total: "",
        loading: false,
        loading3: true,
        modal: false,
        modal2: false,
        qrItem: {},
        upItem: {},
        columns: [{
            type: "selection",
            width: 60,
            align: "center",
          },
          {
            title: "类型",
            slot: "type",
            minWidth: 100,
          },
          {
            title: "金额",
            slot: "price",
            minWidth: 100,
          },
          {
            title: "创建时间",
            key: "time",
            minWidth: 200,
          },

          {
            title: "操作",
            minWidth: 150,
            align: "center",
            slot: "action",
          },
        ],
        data: [],
        type: "-1",
        load: true
      };
    },
    created() {
      this._getData();
    },

    methods: {

      // 活码上传
      ok() {
        if (!this.upItem.url) {
          this.$Message.warning({
            background: true,
            content: '请上传收款码',
          });
          this.loading3 = false;
          this.$nextTick(() => {
            this.loading3 = true;
          });
          return
        }
        if (this.dataUp.category == 1 && !this.dataUp.price) {
          this.$Message.warning({
            background: true,
            content: '请输入金额',
          });
          this.loading3 = false;
          this.$nextTick(() => {
            this.loading3 = true;
          });
          return
        }
        postGeekPay({
          type: this.dataUp.type,
          category: this.dataUp.category,
          url: this.upItem.url,
          price: this.dataUp.price,
        }).then((res) => {
          if (res.code == 200) {
            this.$Message.success({
              background: true,
              content: res.msg,
            });
            this._getData();
          } else {
            this.$Message.error({
              background: true,
              content: res.msg,
            });
          }
          this.loading3 = false;
          this.$nextTick(() => {
            this.loading3 = true;
          });
          this.modal2 = false
        });
      },


      //  上传成功钩子
      handleSuccess2(res, file, fileList) {
        this.$Message.destroy()
        this.upItem = res.data
        this.$Message.success({
          background: true,
          content: res.msg,
        });
      },
      // 上传失败钩子
      onError() {
        this.$Message.destroy()
        this.$Message.error({
          background: true,
          content: "上传失败",
        });
      },
      // 上传之前钩子
      beforeUpload2(res, file, fileList) {
        this.$Message.loading({
          content: '正在上传...',
          duration: 0
        });
      },
      // 文件格式验证失败时的钩子
      handleFormatError(file) {
        this.$Message.destroy()
        this.$Message.error({
          background: true,
          content: "请选择jpg、jpeg、png或gif格式图片",
        });
      },
      // 文件超出指定大小限制时的钩子
      handleMaxSize(file) {
        this.$Message.destroy()
        this.$Message.error({
          background: true,
          content: "图片大小不能超过5Mb",
        });
      },
      // 获取列表
      _getData() {
        getGeekPay({
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          type: this.type
        }).then((res) => {
          this.data = res.data.data;
          this.total = res.data.total;
          this.Selection = [];
          this.load = false
        });
      },
      // 查看
      readClick(row) {
        this.qrItem = row
        this.modal = true
      },
      // 上传
      upload() {
        this.upItem = {}
        this.modal2 = true
      },

      // 删除
      del(id) {
        this.$Modal.confirm({
          title: "删除确认",
          content: "删除后无法恢复，是否继续？",
          onOk: () => {
            this.delFunction(id);
          },
        });
      },
      // 删除所选
      allDel() {
        let arr = [];
        this.Selection.map(function (item) {
          arr.push(item.id);
        });
        this.del(arr);
      },
      // 删除方法
      delFunction(id) {
        this.loading = true
        this.load = true
        delGeekPay({
          id: id,
        }).then((res) => {
          if (res.code == 200) {
            this.$Message.success({
              background: true,
              content: res.msg,
            });
            this._getData();
          } else {
            this.$Message.error({
              background: true,
              content: res.msg,
            });
          }
          this.loading = false
          this.Selection = [];
        });
      },
      // 分页跳转
      pageChange(val) {
        this.pageIndex = val;
        this.load = true
        this._getData();
      },
      pageSizeChange(val) {
        this.pageIndex = 1
        this.load = true
        this.pageSize = val;
        this._getData();
      },
      //多选
      handleSelectChange(val) {
        this.Selection = val;
      },






    },
  };
</script>

<style lang="less" scoped>
  .sm {
    font-size: 12px;
    line-height: 18px;
  }

  .card-menu {
    /deep/ .ivu-radio-wrapper-checked {
      background: #2d8cf0;
      color: #fff;
    }
  }

  .input-main {
    padding: 5px 10px;
    text-align: left;
  }

  /deep/.ivu-modal-body {
    text-align: center;
  }

  /deep/ .ivu-upload-drag {
    width: 300px;
    height: 300px;
    display: inline-block;
    margin: 0 auto;
    position: relative;

    .qr-img {
      width: 100%;
      height: 100%;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .qr-icon {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 200px;
      transform: translate(-50%, -50%);
    }
  }
</style>